import Button from "../../../components/base/Button";
import IntroVideo from "@/assets/video/DMI-Designs-Intro.mp4";
import HeroBG from "@/assets/images/hero-bg.jpg";

export default function HeroSectionVideo() {
  return (
    <section id="home" className="relative min-h-screen flex items-center bg-white overflow-hidden">
      {/* Background Image with Backdrop */}
      <div className="absolute inset-0 z-0">
        <img
          src={HeroBG}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full z-10 pt-20 pb-10 h-full flex flex-col justify-center">

        {/* Desktop: Content on top. Mobile: Content on bottom */}
        <div className="flex flex-col-reverse md:flex-col w-full h-full justify-center">

          <div className="flex flex-col items-center justify-center text-center max-w-5xl mx-auto space-y-6 mt-8 md:mt-0">
            <div className="space-y-4">
              <h1 className="text-3xl md:text-5xl lg:text-5xl xl:text-6xl font-bold text-white leading-[1.2] pb-2 pt-4 md:pt-0">
                Filing-Ready Architectural Drafting &<br className="hidden md:block" /> Precise Low Voltage Takeoff/Proposal Service
              </h1>
              <p className="text-lg lg:text-xl text-white/80 max-w-4xl mx-auto leading-relaxed">
                Empowering general contractors, architects, and developers to scale their operations without increasing overhead. We deliver precise CAD drafts and meticulously quantified material takeoffs with efficient turnaround aligned to your project timelines—many projects are delivered within 24–48 hours depending on scope. You focus on winning the work. We’ll handle the design and detail.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto">
              <a href="/services/drafting"><Button variant="primary" size="lg" className="w-full sm:w-auto">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-ruler-line"></i>
                </div>
                Drafting Services
              </Button></a>
              <a href="/services/takeoff"><Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-[#e18033] hover:border-[#e18033] hover:text-white transition-colors">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-calculator-line"></i>
                </div>
                Takeoff Services
              </Button></a>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center justify-center space-x-8 md:space-x-12 pt-2 pb-6 w-full text-center">
              <div>
                <div className="text-2xl md:text-3xl font-bold text-[#e18033]">500+</div>
                <div className="text-xs md:text-sm text-[#889d8f] mt-1 uppercase tracking-wider font-semibold">Projects Supported</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-[#e18033]">21+</div>
                <div className="text-xs md:text-sm text-[#889d8f] mt-1 uppercase tracking-wider font-semibold">Years Experience</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-[#e18033]">98%</div>
                <div className="text-xs md:text-sm text-[#889d8f] mt-1 uppercase tracking-wider font-semibold">Client Retention</div>
              </div>
            </div>
          </div>

          {/* Bottom Wide Video (Moves to Top on Mobile) */}
          <div className="w-full mt-2 md:mt-6 max-w-5xl mx-auto flex-1 flex flex-col justify-center">
            <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl border border-white/10 group mx-auto">
              {/* Decorative glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-br from-[#e18033]/30 via-transparent to-[#e18033]/20 rounded-2xl blur-sm z-0 opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>

              <video
                autoPlay
                loop
                muted
                playsInline
                controls
                className="relative z-10 w-full max-h-[45vh] lg:max-h-[50vh] rounded-2xl aspect-video object-cover"
              >
                <source src={IntroVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
